import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface NotificationBadgeProps {
  count?: number;
  className?: string;
  max?: number;
}

export function NotificationBadge({ count = 0, className, max = 99 }: NotificationBadgeProps) {
  if (count <= 0) return null;

  const displayCount = count > max ? `${max}+` : count.toString();

  return (
    <Badge variant="destructive" className={cn('flex h-5 min-w-[20px] items-center justify-center px-1', className)}>
      {displayCount}
    </Badge>
  );
}
